import { IRequestDeleteHoliday } from '../interfaces/request-delete-holiday.interface';
import { IRequestDeleteSchoolDay } from '../interfaces/request-delete-schoolday.interface';
import { IRequestSaveHoliday } from '../interfaces/request-save-holiday.interface';
import { IRequestSaveWorkingDays } from '../interfaces/request-save-workingdays.interface';
import { ISchoolCalendarPreferences } from '../interfaces/school-calendar-preferences.interface';
import { SchoolDay } from '../models/school-day.model';
import { SCHOOL_CALENDAR_API } from '../values/school-calendar.values';
import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';

class SchoolCalendarServiceClass {

  async holidays(ownerId: number, year: string, startDate: string, endDate: string, ownerType = 'ORG') {
    const req = SCHOOL_CALENDAR_API.GET_HOLIDAYS
      .replace('{ownerType}', ownerType)
      .replace('{ownerId}', ownerId.toString() )
      .replace('{year}', year )
      .replace('{startDate}', startDate )
      .replace('{endDate}', endDate );
    return RequestProvider.get(req);
  }

  async workingDays(organizationId: number) {
    return RequestProvider
      .get(`${SCHOOL_CALENDAR_API.GET_WORKING_DAYS}?organizationId=${organizationId}`);
  }

  async schooldays(organizationId: number, year: string, startDate: string, endDate: string) {
    const req = SCHOOL_CALENDAR_API.GET_SCHOOLDAYS
      .replace('{organizationId}', organizationId.toString())
      .replace('{year}', year)
      .replace('{startDate}', startDate)
      .replace('{endDate}', endDate);
    return RequestProvider.get(req);
  }

  async schooldaysActive(organizationId: number) {
    return RequestProvider
      .get(`${SCHOOL_CALENDAR_API.GET_SCHOOLDAYS_ACTIVE}?organizationId=${organizationId}`);
  }

  async schooldaysList(organizationId:number) {
    return RequestProvider
      .get(`${SCHOOL_CALENDAR_API.GET_SCHOOLDAYS_LIST}?organizationId=${organizationId}`);
  }

  async getColorPreferences(organizationId: number) {
    const req = SCHOOL_CALENDAR_API.GET_COLORS_PREFERENCE
      .replace('{organizationId}', String(organizationId));
    return RequestProvider.get(req);
  }

  async saveWorkingDays(data:IRequestSaveWorkingDays) {
    return RequestProvider.post(SCHOOL_CALENDAR_API.SAVE_WORKING_DAYS, data);
  }

  async saveSchooldays(schoolday:SchoolDay) {
    try {
      return RequestProvider
      .post(SCHOOL_CALENDAR_API.SAVE_SCHOOLDAYS, { schoolDays: [schoolday] });
    } catch(error) {
      throw ErrorProvider.getError(error.data.error);
    }
  }

  async saveHolidays(holiday:IRequestSaveHoliday) {
    return RequestProvider.post(SCHOOL_CALENDAR_API.SAVE_HOLIDAYS, {
      ownerId: holiday.ownerId,
      ownerType: holiday.ownerType,
      holidays: [holiday]
    });
  }

  async deleteHolidays(holiday: IRequestDeleteHoliday) {
    return RequestProvider
      .remove(
        SCHOOL_CALENDAR_API.DELETE_HOLIDAYS,
        { holidayPlanId: [holiday.holidayPlanId] }
      );
  }

  async deleteSchoolDay(schoolday:IRequestDeleteSchoolDay) {
    return RequestProvider
      .remove(SCHOOL_CALENDAR_API.DELETE_SCHOOLDAYS,
        { schoolDayId: [schoolday.schoolDayId] }
      );
  }

  async saveColorsPreference(req: ISchoolCalendarPreferences): Promise<any> {
    return RequestProvider.post(SCHOOL_CALENDAR_API.SAVE_COLORS_PREFERENCE, req );
  }

  async getSchoolCalendarById(shooldayId: number) {
    const path = SCHOOL_CALENDAR_API.GET_SCHOOL_CALENDAR_BY_ID
      .replace('{shooldayId}', String(shooldayId));
    return RequestProvider.get(path);
  }

  async getSchoolCalendarList(entityType: string, entityId: number, endDate: string, startDate: string) {
    const path = SCHOOL_CALENDAR_API.GET_SCHOOL_CALENDAR_LIST
      .replace('{entityType}', entityType)
      .replace('{entityId}', String(entityId))
      .replace('{endDate}', endDate)
      .replace('{startDate}', startDate);
    return RequestProvider.get(path);
  }

}

export const SchoolCalendarService = new SchoolCalendarServiceClass();
